module.exports = __webpack_public_path__ + "img/failed.07f9b105.svg";